import { render, staticRenderFns } from "./RightButton.vue?vue&type=template&id=1cdbffcc&"
import script from "./RightButton.vue?vue&type=script&lang=js&"
export * from "./RightButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports